<template>
  <div class="padding-md">
    <el-row :gutter="10">
      <el-col :md="8">
        <el-form label-width="70px" autoComplete="on" :model="registerForm" :rules="registerRules" ref="registerForm" label-position="left">
          <el-form-item prop="username" label="用户名">
            <el-input name="username" type="text" v-model="registerForm.username" autoComplete="off"
                      placeholder="请输入手机号"/>
          </el-form-item>
          <el-form-item prop="verificationCode" class="code" label="验证码">
            <el-input name="inputCode" placeholder="请输入验证码" v-model="registerForm.verificationCode" autoComplete="off">
              <template slot="append">
                <el-button :disabled="isDisable"
                           class="code-btn"
                           @click.prevent="sendSmsCode('registerForm')">{{getCode_btn}}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" label="密码">
            <el-input name="password" :type="pwdType" v-model="registerForm.password"
                      autoComplete="off"
                      placeholder="请输入密码"></el-input>
            <span class="show-pwd" @click="showPwd">
          <font-awesome-icon icon="eye"></font-awesome-icon>
        </span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" class="sign-up" :loading="loading" @click.native.prevent="handleUpdatePassword">
              修改
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {isvalidPassword, isvalidPhoneNumber} from '@/utils/validate'
  import {getModifyPasswordCode, postModifyPasswordCode, changePassword } from '@/api/users'
  export default {
    name: 'password',
    data() {
      const validatePhoneNo = (rule, value, callback) => {
        if (value.indexOf(' ') !== -1) {
          callback(new Error('手机号不能有空格'))
        } else if (!isvalidPhoneNumber(value)) {
          callback(new Error('手机号格式不正确'))
        } else {
          callback()
        }
      }
      const validatePass = (rule, value, callback) => {
        if (!value || value.indexOf(' ') !== -1) {
          callback(new Error('密码不能为空'))
        } else if (!isvalidPassword(value)) {
          callback(new Error('密码至少包含一个大写、小写字母和数字,长度在[8-20]之间'))
        } else {
          callback()
        }
      }
      const validateCode = (rule, value, callback) => {
        if (value && value.trim().length > 0) {
          getModifyPasswordCode({
            phoneNumber: this.registerForm.username,
            code: this.registerForm.verificationCode,
          }).then(result => {
            if (!result || !result.code || result.code !== value) {
              callback(new Error('验证码错误或者已失效'))
            } else {
              callback()
            }

          }).catch(error => {
            callback(error)
          })
        } else {
          callback(new Error('请输入验证码'))
        }

      }
      return {
        registerForm: {
          username: '',
          password: '',
          verificationCode: ''
        },
        registerRules: {
          username: [{required: true, trigger: 'blur', validator: validatePhoneNo}],
          password: [{required: true, trigger: 'blur', validator: validatePass}],
          verificationCode: [{required: true, trigger: 'blur', validator: validateCode}]
        },
        loading: false,
        pwdType: 'password',
        remainingTime: 60,
        totalTime: 60,
        subInterval: null,
        getCode_btn: '获取验证码',
        isDisable: false
      }
    },
    methods: {
      showPwd() {
        if (this.pwdType === 'password') {
          this.pwdType = ''
        } else {
          this.pwdType = 'password'
        }
      },
      handleUpdatePassword() {
        let self = this
        this.$refs.registerForm.validate(valid => {
          if (valid) {
            self.loading = true
            // self.$store.dispatch('Register', {
            changePassword({
              username: self.registerForm.username,
              password: self.registerForm.password,
              code: self.registerForm.verificationCode,
            }).then(() => {
              self.loading = false
              this.$message({
                message: '密码修改成功',
                type: 'success'
              });
              self.$router.push({ path: '/login' })
            }).catch(() => {
              self.loading = false
            })
          } else {
            this.$message({
              message: '提交失败',
              type: 'error'
            });
            return false
          }
        })
      },
      /**
       * 发送手机验证码
       * @param name
       */
      sendSmsCode(name) {
        this.$refs[name].validateField('username', (err) => {
          if (!err) {
            this.subInterval = setInterval(this.subTime, 1000)
            this.isDisable = true
            postModifyPasswordCode({
              phoneNumber: this.registerForm.username
            }).then(() => {
              this.$message({
                message: '验证码发送成功',
                type: 'success'
              });
            }).catch(() => {
              this.totalTime = 0
            })
          }
        })
      },
      subTime: function () {
        let totalTime = parseInt(this.totalTime)
        if (totalTime <= 1) {
          this.totalTime = this.remainingTime
          clearInterval(this.subInterval)
          this.subInterval = null
          this.getCode_btn = '获取验证码'
          this.isDisable = false
        } else {
          this.getCode_btn = '重新获取(' + (totalTime - 1) + ')s'
          this.totalTime = totalTime - 1
        }
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss">
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
  .code-btn {
    height: 40px;
    width: 126px;
    display: inline-block;
  }
  .sign-up {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// password.vue?031cb0a5